/**
 * @ngdoc function
 * @name translateApp.factory:LocaleService
 * @description
 * # LocaleService
 * Service for setting/getting current locale
 */
angular.module('iconoglobe')
